import { t } from "../lib/i18n";
/**
 * TAXONOMÍA TRIANGULADA — fuente única de verdad para las 3 patas del match.
 * Empresa (vendedor) · Searcher · Inversor responden sobre las MISMAS dimensiones
 * para que el Match Engine pueda cruzarlas automáticamente.
 */

export const SECTORS = [
  "Industrial / Manufactura",
  "Servicios B2B",
  "Servicios Profesionales / Consultoría",
  "Software / SaaS",
  "E-commerce",
  "Retail / Comercio",
  "Distribución / Mayorista",
  "Alimentación y Bebidas",
  "Agroalimentario",
  "Salud",
  "Farmacia / Biotecnología",
  "Educación / Formación",
  "Construcción / Inmobiliario",
  "Hostelería / Turismo",
  "Logística / Transporte",
  "Energías Renovables / Medioambiente",
  "Automoción / Movilidad",
  "Medios / Marketing / Publicidad",
  "Servicios Financieros / Seguros",
  "Telecomunicaciones / IT",
  "Otros",
];

// Valor sentinel del selector del vendedor: abre un campo libre para escribir el sector.
export const CUSTOM_SECTOR = "__custom__";
export const SELLER_SECTORS = SECTORS.filter((s) => s !== "Otros");

// ===== Geografía: España por CCAA + Resto del mundo =====
// "España (toda)" es un atajo que en el frontend auto-selecciona las 17 CCAA + Ceuta/Melilla.
// El backend trabaja siempre sobre la lista expandida.
export const SPAIN_ALL = "España (toda)";
export const REST_OF_WORLD = "Resto del mundo";

export const SPAIN_REGIONS = [
  "Andalucía",
  "Aragón",
  "Asturias",
  "Baleares",
  "Canarias",
  "Cantabria",
  "Castilla-La Mancha",
  "Castilla y León",
  "Cataluña",
  "Comunidad Valenciana",
  "Extremadura",
  "Galicia",
  "La Rioja",
  "Madrid",
  "Murcia",
  "Navarra",
  "País Vasco",
  "Ceuta",
  "Melilla",
];

// Lista completa válida (lo que el backend acepta). NO incluye SPAIN_ALL — ése es solo atajo de UI.
export const GEOGRAPHIES = [...SPAIN_REGIONS, REST_OF_WORLD];

// ===== Buckets para sliders de Ticket y Facturación =====
// Si el valor máximo == último bucket, se interpreta como "sin tope".
export const TICKET_BUCKETS = [
  0, 100_000, 250_000, 500_000, 1_000_000, 2_500_000, 5_000_000, 10_000_000, 25_000_000,
];
export const REVENUE_BUCKETS = [
  0, 500_000, 1_000_000, 2_500_000, 5_000_000, 10_000_000, 25_000_000, 50_000_000,
];

export const formatBucketEUR = (n) => {
  if (n == null) return "—";
  if (n >= 1_000_000) {
    const v = n / 1_000_000;
    return `${v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)}M€`;
  }
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}k€`;
  return `${n}€`;
};

export const RECURRENCE_LEVELS = ["Alta (>70%)", "Media (30-70%)", "Indiferente"];

export const EDUCATION_LEVELS = [
  "MBA",
  "Máster especializado",
  "Grado universitario",
  "Otra formación",
];

export const BACKGROUNDS = [
  "Consultoría estratégica",
  "Banca de inversión / M&A",
  "Private equity / VC",
  "Operaciones / Dirección general",
  "Emprendimiento",
  "Auditoría / Finanzas",
  "Otro",
];

export const FUND_MODELS = [
  { value: "traditional", label: t("Tradicional"), desc: t("Capital de búsqueda levantado de un grupo de inversores") },
  { value: "self_funded", label: t("Self-funded"), desc: t("Financias tu propia búsqueda con recursos propios") },
  { value: "accelerator", label: t("Accelerator / Holding"), desc: t("Respaldado por una aceleradora o holding de EtA") },
  { value: "exploring", label: t("Explorando"), desc: t("Aún estoy definiendo mi modelo") },
];

export const SEARCH_STAGES = [
  { value: "raising", label: t("Levantando capital"), desc: t("Preparando el fund y cerrando compromisos") },
  { value: "searching", label: t("Búsqueda activa"), desc: t("Capital comprometido, evaluando empresas") },
  { value: "under_loi", label: t("Bajo LOI"), desc: t("En exclusividad con una empresa, abierto a alternativas") },
];

export const CONTINUITY_PREFS = [
  { value: "team_stays", label: t("Equipo se queda"), desc: t("Prefiero empresas con equipo directivo que continúe") },
  { value: "operate_myself", label: t("Operar yo"), desc: t("Quiero asumir la dirección general del día a día") },
  { value: "flexible", label: t("Flexible"), desc: t("Depende de la empresa y la oportunidad") },
];

export const FUND_MODEL_LABEL = Object.fromEntries(FUND_MODELS.map((m) => [m.value, m.label]));
export const SEARCH_STAGE_LABEL = Object.fromEntries(SEARCH_STAGES.map((s) => [s.value, s.label]));
